export const exhibitions = {
   get: {
      more: "GET/EXHIBITIONS_MORE",
      call: "GET/EXHIBITIONS_CALL",
      send: "GET/EXHIBITIONS_SEND",
      success: "GET/EXHIBITIONS_SUCCESS",
      fail: "GET/EXHIBITIONS_FAIL",
   },
} as const;

export const nows = {
   get: {
      call: "GET/NOWS_CALL",
      send: "GET/NOWS_SEND",
      success: "GET/NOWS_SUCCESS",
      fail: "GET/NOWS_FAIL",
   },
} as const;

export const nowContents = {
   get: {
      call: "GET/NOWCONTENTS_CALL",
      send: "GET/NOWCONTENTS_SEND",
      success: "GET/NOWCONTENTS_SUCCESS",
      fail: "GET/NOWCONTENTS_FAIL",
   },
} as const;

export const slidingMenu = {
   open: "SLIDING_MENU_OPEN",
   close: "SLIDING_MENU_CLOSE",
   toggle: "SLIDING_MENU_TOGGLE",
   openSuccess: "SLIDING_MENU_SUCCESS",
   closeSuccess: "SLIDING_MENU_SUCCESS",
} as const;

export const toolMenu = {
   open: "TOOL_MENU_OPEN",
   close: "TOOL_MENU_CLOSE",
   toggle: "TOOL_MENU_TOGGLE",
} as const;

export const dimensions = {
   sync: "WINDOW_DIMENSIONS_SYNC",
} as const;

export const dataScroll = {
   none: "DATA_SCROLL_NONE",
   end: "DATA_SCROLL_END",
   endArea: "DATA_SCROLL_ENDAREA",
};

export const XSSearch = {
   opening: "XSSEARCH_OPENING",
   opened: "XSSEARCH_OPENED",
   closing: "XSSEARCH_CLOSING",
   closed: "XSSEARCH_CLOSED",
};
